export function formatBytes(x) {
    if (x == null) return '—';
    let v = Number(x), i = 0;
    const u = ['B','KB','MB','GB','TB'];
    while (v >= 1024 && i < u.length - 1) { v /= 1024; i++; }
    return v.toFixed(2) + ' ' + u[i];
}
export function formatDate(x) {
    if (!x) return '—';
    const d = new Date(x);
    return d.toLocaleString();
}

export function formatDateDash(x) {
  if (!x) return '—';
  const d = new Date(x);
  return `до ${d.toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  })}`;
}


export function daysLeft(expireAt) {
    if (!expireAt) return '—';
    const ms = new Date(expireAt) - new Date();
    if (ms <= 0) return '0';
    return Math.ceil(ms / (24*3600*1000)).toString();
}
